import { useAppStore } from '@/stores/app';
import type { AgGridReact } from 'ag-grid-react';
import clsx from 'clsx';
import React, { type FC, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/react/shallow';

import globalStyles from '../../../styles/index.module.css';
import styles from '../styles.module.css';
import type { StudiesContentProps } from '../types';

import NoStudies from './NoStudies';
import TableData, { type StudyRow } from './TableData';

export const StudiesContent: FC<StudiesContentProps> = ({ isLoading, studies, onFilteredTotalChanged }) => {
  const { t } = useTranslation('studies');
  const gridRef = useRef<AgGridReact<StudyRow> | null>(null);
  const selectedOrg = useAppStore(useShallow(state => state.selectedOrganization?.id));

  const totalStudies = useMemo(() => studies?.records?.length || 0, [studies?.records]);
  const showEmptyState = useMemo(() => !isLoading && totalStudies === 0, [isLoading, totalStudies]);

  return (
    <main className={styles.container}>
      <section aria-label={t('table_view')} className={clsx(styles.tableContainer, globalStyles.scrollbars)}>
        {showEmptyState ? (
          <NoStudies />
        ) : (
          selectedOrg && (
            <TableData gridRef={gridRef} onFilteredTotalChanged={onFilteredTotalChanged} selectedOrg={selectedOrg} />
          )
        )}
      </section>
    </main>
  );
};
